<style scoped>

</style>
<template>
  <div>
    <Modal
      v-model="config.modal"
      :title="'设置为银行退款: ' + edit_expense_group.name"
      width="730"
      :loading="config.loading"
      ok-text="确定"
      @on-ok="setOK"
    >
      <div class="line">
        <Checkbox
          v-model="edit_expense_group.is_refund"
          size="large"
        >
          银行已退款?
        </Checkbox>
        <template v-if="edit_expense_group.payment_type === 1 || edit_expense_group.payment_type === 2 || edit_expense_group.payment_type === 3">
          <div
            v-if="edit_expense_group.expenses && edit_expense_group.expenses.length"
            style="font-size: 14px; margin-top: 10px"
          >
            各项目退款金额：
          </div>
          <div
            v-for="expense in edit_expense_group.expenses"
            :key="expense.id"
            style="margin-top: 10px"
          >
            <span>{{ expense.name }}：</span>
            <span><Input
              v-model="expense.return_price"
              type="number"
              style="width: 150px"
              @on-change="hanleChange"
            /></span>
          </div>
        </template>
        <!-- <template v-if="edit_expense_group.payment_type === 3">
                    <div>退款金额：<Input v-model="edit_expense_group.return_price" @on-change="hanleChange" type="number" style="width: 150px" /></div>
                </template> -->
        <RichText
          style="margin-top: 20px"
          :config="rich_text_config"
          :text.sync="edit_expense_group.desc"
        />
      </div>
    </Modal>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    data() {
      return {
        expense_group: {},
        edit_expense_group: {
          id_refund: false,
          desc: '',
          expenses: [],
          return_price: ''
        },
        config: {
          modal: false,
          loading: true
        },
        rich_text_config: {
          show: true,
          fixed: false,
          show_handler: false,
          title: '备注'
        },
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      hanleChange(e) {
        const value = parseFloat(e.target.value)
        if (value > 0) {
          this.edit_expense_group.is_refund = true
        } else {
          let is_refund = false
          if (this.edit_expense_group.expenses) {
            this.edit_expense_group.expenses.forEach(expense => {
              if (parseFloat(expense.return_price) > 0) {
                is_refund = true
              }
            })
          }
          this.edit_expense_group.is_refund = is_refund
        }
      },
      edit(expense_group) {
        this.config.modal = true;
        if (expense_group.payment_type === 1 || expense_group.payment_type === 2 || expense_group.payment_type === 3) {
          this.$util.ajax(this.$util.api.query_expense_group_expense, {
            params: {
              id: expense_group.id
            }
          }).then(res => {
            if (res.data.code === 1) {
              this.expense_group = expense_group
              this.edit_expense_group = Util.clone(expense_group)
              this.edit_expense_group.expenses = res.data.data.expenses
            } else {
              this.$Modal.error({title: '提示', content: res.data.msg})
            }
          })
        } else {
          this.expense_group = expense_group
          this.edit_expense_group = expense_group
        }
      },
      hide() {
        this.config.modal = false;
      },
      resetLoading() {
        this.config.loading = false;
        setTimeout(() => {
          this.config.loading = true;
        }, 500);
      },
      setOK() {
        const payment_type = this.edit_expense_group.payment_type 
        if (payment_type === 1 || payment_type === 2 || payment_type === 3) {
          if (this.edit_expense_group.is_refund) {
            if (this.edit_expense_group.return_expense_group_id > 0) {
              this.resetLoading()
              this.$Modal.error({
                title: '错误提示',
                content: '【退款单】不能进行退款!'
              })
              return
            }
            if (this.edit_expense_group.refund_expense_group_id > 0) {
              this.resetLoading()
              this.$Modal.error({
                title: '错误提示',
                content: '【付款单】已退款!'
              })
              return
            }
            if (payment_type === 3 && this.edit_expense_group.total_price < this.edit_expense_group.return_price) {
              this.resetLoading()
              this.$Modal.error({
                title: '错误提示',
                content: '【退款】金额不能大于【付款】金额!'
              });
              return
            } else if (payment_type === 1) {
              let err_msg = ''
              const expenses = this.edit_expense_group.expenses
              const expnese_length = expenses.length
              let total_return_price = 0
              for (let i = 0; i < expnese_length; i++) {
                const expense = expenses[i]
                // console.log('expense.price', expense.price, expense.return_price)
                if (parseFloat(expense.price) < parseFloat(expense.return_price)) {
                  err_msg += `付款子项${i + 1}的【退款】金额不能大于【付款】金额!<br/>`
                }
                total_return_price += parseFloat(expense.return_price)
              }
              if (total_return_price <= 0) {
                err_msg += `请填写退款金额<br/>`
              }
              if (err_msg) {
                console.log('err_msg', err_msg)
                this.resetLoading()
                this.$Modal.error({
                  title: '错误提示',
                  content: err_msg
                })
                return
              }
            }
          }
        }
        Util.ajax.post(Util.api.expense_group_refund, this.edit_expense_group).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            // this.expense_group.is_refund = data.expense_group.is_refund;
            // this.expense_group.desc = data.expense_group.desc;
            // this.edit_expense_group.is_refund = data.expense_group.is_refund;
            // this.edit_expense_group.desc = data.expense_group.desc;
            // this.edit_expense_group.refund_expense_group_id = data.expense_group.refund_expense_group_id
            this.$emit('refund', data.expense_group, data.refund_expense_group)
            this.hide();
          } else {
            this.resetLoading();
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.resetLoading();
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      }
    }
  }
</script>
